// extracted by mini-css-extract-plugin
module.exports = {"container_view":"styles_container_view__3gtyp","title":"styles_title__qCKVN"};